import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { withBrand } from '../../../../../../providers/BrandProvider';
import { FormBoxInput } from '../../../../../shared/forms';
import OptionListMultipleHeading from './OptionListMultipleHeading/OptionListMultipleHeading';

import './OptionList.scss';

const SINGLE_CHOICE = 'SINGLE_CHOICE';
const MULTIPLE_CHOICE = 'MULTIPLE_CHOICE';

export class OptionList extends Component {
  static propTypes = {
    selected: PropTypes.object,
    listIndex: PropTypes.number,
    productType: PropTypes.object,
    productItem: PropTypes.object,
    onOptionChange: PropTypes.func,
    brand: PropTypes.object,
  };

  render() {
    const {
      listIndex,
      selected = {},
      productType: { productTypeId } = {},
      productItem: { id: productItemId, productOptionsList = {} } = {
        productOptionsList: {},
      },
      onOptionChange,
      brand: { secondaryColor } = {},
      t,
    } = this.props;

    const list = productOptionsList[listIndex] || {};

    let selectedId = null;

    // Find selected id in single choice mode
    if (list.type === SINGLE_CHOICE) {
      const selectedOptions = Object.keys(selected.options)
        .map((id) => {
          return { id, selected: selected.options[id].selected };
        })
        .filter((option) => option.selected);

      selectedId = selectedOptions.length ? selectedOptions[0].id : undefined;
    }

    return (
      list.type && (
        <div className="c-option-list">
          <div className="c-option-list__separator" />
          {list.type === SINGLE_CHOICE && (
            <Fragment>
              <h5
                className={`c-option-list__heading${
                  selected.valid ? '' : ' has-error'
                }`}
              >
                {t('event.purchase.please.select.option')}
              </h5>
              <div className="c-option-list__content">
                <select
                  className="c-select"
                  onChange={onOptionChange}
                  value={`${productTypeId}:${productItemId}:${selectedId}:${listIndex}`}
                >
                  {list.options.map((option) => (
                    <option
                      key={option.id}
                      value={`${productTypeId}:${productItemId}:${option.id}:${listIndex}`}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </Fragment>
          )}
          {list.type === MULTIPLE_CHOICE && (
            <Fragment>
              <OptionListMultipleHeading
                valid={selected.valid}
                list={list}
                t={t}
              />
              <div className="c-option-list__content">
                {list.options.map((option) => (
                  <FormBoxInput
                    key={option.id}
                    type={list.type}
                    size="small"
                    value={`${productTypeId}:${productItemId}:${option.id}:${listIndex}`}
                    label={option.name}
                    color={secondaryColor}
                    checked={selected.options[option.id].selected}
                    disabled={selected.options[option.id].disabled}
                    onChange={onOptionChange}
                  />
                ))}
              </div>
            </Fragment>
          )}
        </div>
      )
    );
  }
}

export default withTranslation()(withBrand(OptionList));
